module.exports = __webpack_public_path__ + "static/media/somnomed.6290cfaf.png";